<template>
    <div class="threejsContainer">
        <div class="containerTitle">1-20.框架：相机平滑切换-{{controllerText}}<button id="infoButton" @click="switchControl">切换控制器</button><button id="infoButton" @click="addResource">加载资源</button>{{globalProgress}}{{progress}}</div>
        <div ref="container" class="containerBody"></div>
    </div>
</template>
  
<script>
  import * as THREE from 'three';
  import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
  import {RendererManager} from '@/core/RendererManager.js';
  import EventBus from '@/core/EventBus.js';
  import CameraController from '@/core/CameraController.js';
  import SceneManager from '@/core/SceneManager.js';
  import {resourceManager} from '@/core/ResourceManager.js';
  
  
  export default {
    data() {
      return {
        controllerSign:0,
        controllerText: "orbit",
        scene: null,
        camera: null,
        cameraController: null,
        rendererMng: null,
        sceneMng: null,
        currentMesh: null,
        globalProgress:0,
        progress: 0,
        lastTime: 0,
        window: {
          width: 0,
          height: 0
        },
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      this.initCubes();
      this.animate();
    },
    methods: {
      addResource() {
        resourceManager.add('texture', 'groundTex', 'textures/livingroom.jpg'); // 纹理
        resourceManager.add('gltf', 'character', 'glb/cube.glb'); // GLB模型
        resourceManager.add('json', 'sceneConfig', 'fonts/gentilis_bold.typeface.json'); // JSON配置
        resourceManager.add('audio', 'bgm', 'mp3/gohome.mp3'); // 普通音频
        
        resourceManager.loadAll(
        // 整体进度回调
        (globalProgress) => {
          this.globalProgress = globalProgress.toFixed(1);
          console.log(`总加载进度：${globalProgress.toFixed(1)}%`);
          // 示例：更新DOM进度条
          // document.getElementById('global-progress').style.width = `${globalProgress}%`;
        },
        // 单个资源进度回调
        (key, progress) => {
          this.progress = key+":"+progress.toFixed(1);
          console.log(`资源 ${key} 加载进度：${progress.toFixed(1)}%`);
        },
        // 加载完成回调
        (cache) => {
          console.log('所有资源加载完成', cache);
          // 获取并使用资源
          const groundTex = resourceManager.get('groundTex');
          const character = resourceManager.get('character');
          const sceneConfig = resourceManager.get('sceneConfig');
          const bgm = resourceManager.get('bgm');

          console.log(groundTex);
          console.log(sceneConfig);
          // 模型添加到场景
          this.scene.add(character.scene);
          // 播放背景音乐
          bgm.play();
        },
        // 错误回调
        (error, key) => {
          alert(`资源 ${key} 加载失败：${error.message}`);
        }
      );
      },
      switchControl() {
        this.controllerSign++;
        if(this.controllerSign%4==0) {
          this.cameraController.switchMode("orbit");
          this.controllerText = "orbit";
        }else if(this.controllerSign%4==1) {
          this.cameraController.switchMode("firstPerson");
          this.controllerText = "firstPerson";
        }else if(this.controllerSign%4==2) {
          this.cameraController.switchMode("pointerLock");
          this.controllerText = "pointerLock";
        }else if(this.controllerSign%4==3) {
          this.cameraController.switchMode("map");
          this.controllerText = "map";
        }
      },
      initCubes() {
        const geometry = new THREE.BoxGeometry(4,4,4);
        for(var i=0; i<100; i++){
          const randomColor = Math.random() * 0xffffff;
          const material = new THREE.MeshBasicMaterial({ color: randomColor });
          var cube = new THREE.Mesh(geometry, material);
          cube.position.set(
            (Math.random() - 0.5) * 100, // x 坐标: -100 到 100
            (Math.random()) * 100, // y 坐标: -100 到 100
            (Math.random() - 0.5) * 100  // z 坐标: -100 到 100
          );
          this.scene.add(cube);
        }
      },
      animate() {
        this.animationId = requestAnimationFrame(this.animate);

        this.cameraController.update();
        
        this.renderer.render(this.scene, this.camera);
      },
      initEnv(){
        // 初始化渲染器
        this.renderer = RendererManager.genRenderer(); 
        this.$refs.container.appendChild(this.renderer.domElement);
        
        this.sceneMng = SceneManager.getInstance();
        this.scene = this.sceneMng.createScene("mainScene",{backgroundColor:0xffffff});
  
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化相机
        this.camera = genPerspectiveCamera(this.window);
        
        EventBus.on('resize', () => {
          //解决屏幕切换回来时，相机的宽高比不会随窗口变化而变化
          if(!this.$refs.container){
            return ;
          }
          const width = this.$refs.container.clientWidth;
          const height = this.$refs.container.clientHeight;

          // 更新相机
          this.camera.aspect = width / height;
          this.camera.updateProjectionMatrix();
        });

        window.addEventListener('resize', () => {
          //调用事件总线方法
          EventBus.emit('resize');
        });

        this.cameraController = new CameraController(this.camera, this.renderer.domElement);
        this.cameraController.switchMode("orbit");
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);
        
        // 直射光源
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.scene.add(directionalLight);
      },
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      // 释放资源
      if (this.currentMesh) {
        this.scene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }
      
    }
  };
</script>
  
<style>
#infoButton {
  pointer-events: auto !important;
}
</style>
  